import styled from 'styled-components'

export const TrainingCardMatrix = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 1.25rem;
  width: 100%;
`
